<template>
  <div>
    <v-stepper v-model="currentStepNumber">
      <v-stepper-header>
        <v-stepper-step editable :complete="currentStepNumber > 1" step="1" :rules="[rules.firstStepValidated]">Définition du cycle</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :editable="canGoToSecondStep || currentStepNumber >= 2" :complete="currentStepNumber > 2" step="2" :rules="[rules.secondStepValidated]"
          >Progression pédagogique</v-stepper-step
        >
        <v-divider></v-divider>
        <v-stepper-step :editable="canGoToThirdStep" :complete="currentStepNumber > 3" step="3" :rules="[rules.thirdStepValidated]"
          >Situation de réfrence et Organisation du cycle</v-stepper-step
        >
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <v-form ref="cycleForm">
            <div style="padding-top: 10px">
              <v-card>
                <v-app-bar color="#1B8A62">
                  <v-toolbar-title style="color: white">Cycle {{ gce.name }}</v-toolbar-title>
                  <v-spacer />

                  <v-btn :loading="saving" :disabled="saving" icon color="white" @click="submitForm()">
                    <v-icon color="white">mdi-content-save</v-icon>
                  </v-btn>

                  <template v-slot:extension>
                    <v-switch dark v-if="!gce.advancedMode" v-model="gce.advancedMode" label="Mode simplifié" inset></v-switch>
                    <v-switch v-else dark v-model="gce.advancedMode" label="Mode avancé" inset></v-switch>
                  </template>
                </v-app-bar>
                <v-card-text>
                  <div class="md-layout">
                    <!-- Title -->
                    <div class="md-layout-item md-small-size-100 md-size-33">
                      <v-text-field label="Titre" v-model="gce.name" :rules="[rules.required, rules.counter]" counter maxlength="60"></v-text-field>
                    </div>

                    <!-- Destination -->
                    <div class="md-layout-item md-small-size-100 md-size-33 fit-content-radio flex-center">
                      <v-radio-group row v-model="selectedDestinationType" label="Destination" v-on:change="changeDestination" :rules="[rules.required]">
                        <v-radio
                          :value="DestinationTypes.PUBLIC"
                          label="Transversal"
                          :disabled="!canEnableDestinationTypeBasedOnExercisesDesinationTypes(DestinationTypes.PUBLIC)"
                        >
                        </v-radio>
                        <v-radio
                          v-if="canChooseFederationDestinationType"
                          :value="DestinationTypes.FEDERAL"
                          label="Fédération"
                          :disabled="!federations || !federations.length || !canEnableDestinationTypeBasedOnExercisesDesinationTypes(DestinationTypes.FEDERAL)"
                        >
                        </v-radio>
                        <v-radio
                          v-if="canChooseDisciplineDestinationType"
                          :value="DestinationTypes.DISCIPLINE"
                          label="Spécifique"
                          :disabled="!disciplines || !disciplines.length || !canEnableDestinationTypeBasedOnExercisesDesinationTypes(DestinationTypes.DISCIPLINE)"
                        >
                        </v-radio>
                        <v-radio
                          v-if="canChooseCoachDestinationType"
                          :value="DestinationTypes.COACH"
                          label="Entraîneur"
                          :disabled="!coaches || !coaches.length || !canEnableDestinationTypeBasedOnExercisesDesinationTypes(DestinationTypes.COACH)"
                        >
                        </v-radio>
                      </v-radio-group>
                    </div>

                    <!-- Federations -->
                    <div
                      v-if="federations && federations.length && gce != null && gce.destinationType === DestinationTypes.FEDERAL"
                      class="md-layout-item md-small-size-100 md-size-33"
                    >
                      <v-select
                        label="Fédération"
                        :items="federations"
                        item-text="name"
                        item-value="id"
                        v-model="gce.federationId"
                        :rules="[rules.required]"
                        :disabled="federations && federations.length === 1"
                      ></v-select>
                    </div>

                    <!-- Disciplines -->
                    <div
                      v-else-if="disciplines && disciplines.length && gce != null && gce.destinationType === DestinationTypes.DISCIPLINE"
                      class="md-layout-item md-small-size-100 md-size-33"
                    >
                      <v-select
                        label="Discipline"
                        :items="disciplines"
                        item-text="name"
                        item-value="id"
                        v-on:change="changeDiscipline($event)"
                        v-model="gce.disciplineId"
                        :rules="[rules.required]"
                        :disabled="disciplines && disciplines.length === 1"
                      ></v-select>
                    </div>

                    <!-- Coaches -->
                    <div
                      v-else-if="coaches && coaches.length && gce != null && gce.destinationType === DestinationTypes.COACH"
                      class="md-layout-item md-small-size-100 md-size-33"
                    >
                      <v-select
                        label="Entraîneur"
                        :items="coaches"
                        item-text="email"
                        return-object
                        v-on:change="changeCoach($event)"
                        v-model="gce.coach"
                        :rules="[rules.required]"
                        :disabled="coaches && coaches.length === 1"
                      ></v-select>
                    </div>

                    <!-- Description -->
                    <div class="md-layout-item md-size-100 mt-10 mb-10">
                      <wysiwyg v-model="gce.description" label="Description" />
                    </div>
                    <!-- Observables -->
                    <div class="md-layout-item md-small-size-100 md-size-50">
                      <v-label>Observables</v-label>

                      <v-list :key="compKey">
                        <v-list-item v-for="(item, index) in gce.observable" :key="index">
                          <v-text-field label="Nom" v-model="item.name"></v-text-field>
                          <v-text-field label="Description" v-model="item.description"></v-text-field>

                          <v-btn v-on:click="deleteObservable(item)" elevation="0" color="transparent" small class="md-just-icon md-simple md-primary">
                            <v-icon>delete</v-icon>
                            <md-tooltip md-direction="top">Supprimer</md-tooltip>
                          </v-btn>
                        </v-list-item>
                      </v-list>

                      <v-btn v-on:click="addObservable()" style="color: white" color="#1B8A62">Ajouter</v-btn>
                    </div>
                    <!-- Difficulty -->
                    <div class="md-layout-item md-small-size-50 md-size-25 mt-5">
                      <v-label>Niveau de difficulté</v-label>

                      <v-rating color="#1B8A62" background-color="#1B8A62" v-model="gce.difficulté" empty-icon="mdi-hexagon-outline" full-icon="mdi-hexagon" />
                    </div>
                    <!-- Intensity -->
                    <div class="md-layout-item md-small-size-50 md-size-25 mt-5">
                      <v-label>Intensité</v-label>
                      <v-rating color="#1B8A62" background-color="#1B8A62" v-model="gce.intensité" empty-icon="mdi-square-outline" full-icon="mdi-square" />
                    </div>
                    <!-- Description Difficulty -->
                    <div v-if="gce.advancedMode" class="md-layout-item md-small-size-50 md-size-100 mt-5 mb-5">
                      <wysiwyg v-model="gce.descDifficulté" label="Difficulté" />
                    </div>
                    <!-- Description Intensity -->
                    <div v-if="gce.advancedMode" class="md-layout-item md-small-size-50 md-size-100 mt-5 mb-5">
                      <wysiwyg v-model="gce.descIntensité" label="Intensité" />
                    </div>
                    <!-- Age Group -->
                    <div v-if="gce.advancedMode && gce.disciplineId" class="md-layout-item md-small-size-100 md-size-50 pt-5">
                      <div class="md-size-100">
                        <v-select
                          v-model="selectedAgeGroupIds"
                          item-value="id"
                          :items="disciplineAgeGroups"
                          item-text="title"
                          chips
                          :label="ageGroupCustomTitle"
                          multiple
                          outlined
                        ></v-select>
                      </div>
                    </div>
                    <!-- Practice Type -->
                    <div v-if="gce.advancedMode && gce.disciplineId" class="md-layout-item md-small-size-100 md-size-50 pt-5">
                      <div class="md-size-100">
                        <v-select
                          v-model="selectedPracticeTypeIds"
                          item-value="id"
                          :items="disciplinePracticeTypes"
                          item-text="title"
                          chips
                          :label="practiceTypeCustomTitle"
                          multiple
                          outlined
                        ></v-select>
                      </div>
                    </div>
                    <!-- Complementary Information -->
                    <div v-if="gce.advancedMode" class="md-layout-item md-small-size-50 md-size-100 mt-5 mb-5">
                      <wysiwyg v-model="gce.complementaryInformation" label="Informations compémentaires" />
                    </div>
                  </div>
                </v-card-text>

                <!-- next step button -->
                <div style="padding-bottom: 10px" class="md-layout-item md-size-100 text-right">
                  <v-btn @click="onValidateFirstStep()" style="color: white" color="#1B8A62">Continuer</v-btn>
                </div>
              </v-card>
            </div>
          </v-form>
        </v-stepper-content>

        <v-stepper-content step="2">
          <form style="padding-top: 10px">
            <v-card>
              <v-app-bar color="#1B8A62">
                <v-toolbar-title style="color: white">Cycle {{ gce.name }}</v-toolbar-title>
                <v-spacer />

                <v-btn :loading="saving" :disabled="saving" icon @click="submitForm()">
                  <v-icon color="white">mdi-content-save</v-icon>
                </v-btn>

                <template v-slot:extension>
                  <v-switch dark v-if="!gce.advancedMode" v-model="gce.advancedMode" label="Mode simplifié" inset></v-switch>
                  <v-switch v-else dark v-model="gce.advancedMode" label="Mode avancé" inset></v-switch>
                </template>
              </v-app-bar>
              <v-card-text>
                <div class="md-layout">
                  <div class="md-layout-item md-size-100 mb-5">
                    <wysiwyg v-if="gce.advancedMode" v-model="gce.descProgression" label="Description" />
                  </div>

                  <div class="md-layout-item md-small-size-100 md-size-100">
                    <v-label>Etape(s)</v-label>

                    <v-list :key="etapKey">
                      <v-list-item v-for="(item, index) in gce.etape" :key="index">
                        <v-text-field label="Titre" v-model="item.name"></v-text-field>
                        <v-text-field label="Progression" v-model="item.progression"></v-text-field>

                        <v-select
                          :key="compKey"
                          label="Observable(s)"
                          multiple
                          v-model="item.etapeObservable"
                          :items="gce.observable"
                          item-text="name"
                          return-object
                          name="obs"
                        >
                          <v-option v-for="item in gce.observable" :key="item.name" :value="item">{{ item.name }}</v-option>
                        </v-select>

                        <v-btn v-on:click="deleteStep(item)" elevation="0" color="transparent" small class="md-just-icon md-simple md-primary">
                          <v-icon>delete</v-icon>
                          <md-tooltip md-direction="top">Supprimer</md-tooltip>
                        </v-btn>
                      </v-list-item>
                    </v-list>
                    <v-btn v-on:click="addEtap()" style="color: white" color="#1B8A62">Ajouter</v-btn>
                  </div>

                  <div class="md-layout-item md-small-size-50 md-size-100 mt-5">
                    <v-textarea v-if="gce.advancedMode" v-model="gce.infoSupplémentaire" label="Informations supplémentaires"></v-textarea>
                  </div>
                </div>
              </v-card-text>

              <div style="padding-bottom: 10px" class="md-layout-item md-size-100 text-right">
                <v-btn @click="currentStepNumber = 3" style="color: white" color="#1B8A62">Continuer</v-btn>
              </div>
            </v-card>
          </form>
        </v-stepper-content>

        <v-stepper-content step="3">
          <form style="padding-top: 10px">
            <v-card>
              <v-app-bar color="#1B8A62">
                <v-toolbar-title style="color: white">Cycle {{ gce.name }}</v-toolbar-title>
                <v-spacer />

                <v-btn :loading="saving" :disabled="saving" icon @click="submitForm()">
                  <v-icon color="white">mdi-content-save</v-icon>
                </v-btn>

                <template v-slot:extension>
                  <v-switch dark v-if="!gce.advancedMode" v-model="gce.advancedMode" label="Mode simplifié" inset></v-switch>
                  <v-switch v-else dark v-model="gce.advancedMode" label="Mode avancé" inset></v-switch>
                </template>
              </v-app-bar>
              <v-card-text>
                <div class="md-layout">
                  <div class="md-layout-item md-size-100">
                    <v-label>Situation de référence</v-label>

                    <md-empty-state v-if="gce.exerciseRef === undefined">
                      <v-dialog persistent no-click-animation v-model="dialog" transition="dialog-bottom-transition" :retain-focus="false">
                        <template v-slot:activator="{ on: onExRef }">
                          <v-btn v-on="onExRef" style="color: white" color="#1B8A62">
                            <v-icon>mdi-content-paste</v-icon>
                            &nbsp; Choisissez une situation de référence
                          </v-btn>
                        </template>

                        <v-card class="flex flex-column d-flex" style="height: 90vh">
                          <exercises-list-v2
                            :close="closeDialog"
                            canGoBack="false"
                            :onlyRefs="true"
                            v-if="dialog"
                            :authorizedDestinationTypes="getCurrentlyAuthorizedDestinationTypes()"
                            :isShowed="dialogExEneAdd"
                            :gce="gce"
                          />
                        </v-card>
                      </v-dialog>
                    </md-empty-state>
                    <!-- datatable of situation de référence -->
                    <v-simple-table :key="updater" v-else fixed-header>
                      <thead>
                        <tr>
                          <th></th>
                          <th>Titre</th>
                          <th>Destination</th>
                          <th>Type</th>
                          <th>Prérequis</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <!-- Preview -->
                          <td style="width: 350px">
                            <img style="height: 210px" :src="gce.exerciseRef.preview" />
                          </td>
                          <!-- Title -->
                          <td>{{ gce.exerciseRef.title }}</td>
                          <!-- Destination -->
                          <td>
                            {{ destinationTypeItems.find((e) => e.value === gce.exerciseRef.destinationType).text }}
                          </td>
                          <!-- Exercice type -->
                          <td>
                            {{ exerciseTypeItems.find((e) => e.value === gce.exerciseRef.exerciseType).text }}
                          </td>
                          <!-- prerequis -->
                          <td>
                            {{ gce.exerciseRef.prerequis }}
                          </td>
                          <!-- Actions -->
                          <td>
                            <v-dialog :retain-focus="false" v-model="dialogRef" fullscreen hide-overlay transition="dialog-bottom-transition">
                              <template v-slot:activator="{ on }">
                                <v-btn v-on="on" class="md-just-icon md-simple md-primary">
                                  <md-icon>edit</md-icon>
                                  <md-tooltip md-direction="top">Editer</md-tooltip>
                                </v-btn>
                              </template>
                              <v-card>
                                <v-app-bar color="#1B8A62">
                                  <v-toolbar-title style="color: white">Exercices</v-toolbar-title>
                                  <v-spacer />
                                  <v-btn icon dark @click="dialogRef = false">
                                    <v-icon>mdi-close</v-icon>
                                  </v-btn>
                                </v-app-bar>

                                <exercise :id="gce.exerciseRef.id"></exercise>
                              </v-card>
                            </v-dialog>
                          </td>
                          <td>
                            <v-btn
                              @click="
                                gce.exerciseRef = undefined;
                                gce.exerciseRéférence = undefined;
                                updater++;
                              "
                              class="md-just-icon md-simple md-primary"
                            >
                              <md-icon>delete</md-icon>
                              <md-tooltip md-direction="top">Supprimer</md-tooltip>
                            </v-btn>
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </div>
                  <!-- Step -->
                  <div class="md-layout-item md-small-size-100 md-size-100">
                    <v-form ref="etapeForm">
                      <v-expansion-panels>
                        <v-expansion-panel v-for="(itemStep, i) in gce.etape" :key="i">
                          <v-expansion-panel-header>
                            Etape {{ i + 1 }}
                            <v-spacer />
                            {{ itemStep.name }}
                            <v-spacer />

                            <v-spacer />
                            <v-select multiple disabled dense v-model="itemStep.etapeObservable" item-text="name" :items="itemStep.etapeObservable"></v-select>
                          </v-expansion-panel-header>

                          <v-expansion-panel-content>
                            <!-- Session -->
                            <v-data-table :headers="headers" :items="itemStep.session" :key="refresher" sort-by="index">
                              <template v-slot:top>
                                <v-toolbar flat color="white">
                                  <v-toolbar-title>Sessions</v-toolbar-title>
                                  <v-divider class="mx-4" inset vertical></v-divider>

                                  <v-spacer />

                                  <v-dialog :retain-focus="false" transition="dialog-bottom-transition" v-model="dialogSessions">
                                    <template v-slot:activator="{ on: onSession }">
                                      <v-btn color="#1B8A62" dark class="mb-2" v-on="onSession" @click="newSession(itemStep)"> Nouvelle session </v-btn>
                                    </template>

                                    <v-card height="100%">
                                      <v-app-bar color="#1B8A62">
                                        <v-toolbar-title style="color: white">Session</v-toolbar-title>

                                        <v-spacer />

                                        <v-btn icon dark @click="dialogSessions = false">
                                          <v-icon>mdi-close</v-icon>
                                        </v-btn>
                                      </v-app-bar>

                                      <v-card-title>
                                        <v-text-field label="Nom" v-model="editedItem.name" :rules="[rules.required, rules.counter]" counter maxlength="60" />
                                      </v-card-title>

                                      <v-card-text>
                                        <wysiwyg v-model="editedItem.description" label="Description" />

                                        <!-- Blocks -->
                                        <v-card class="mt-5" v-for="(block, idx) in editedItem.block" :key="idx">
                                          <v-card-title>
                                            <v-text-field
                                              dense
                                              v-model="block.name"
                                              label="Nom du bloc"
                                              :rules="[rules.required, rules.counter]"
                                              counter
                                              maxlength="60"
                                            />

                                            <v-spacer />

                                            <v-switch dense label="Circuit" v-model="block.isCircuit" />

                                            <v-spacer />

                                            <v-text-field v-if="block.isCircuit" label="Rep" dense v-model="block.nbRep" :min="1" type="number" />

                                            <v-spacer />

                                            <vue-timepicker v-if="block.isCircuit" label="tps de recup" dense v-model="block.tpsRecup" format="HH:mm:ss" />

                                            <v-spacer />

                                            <v-btn @click="deleteBlock(editedItem, block)">Supprimer</v-btn>
                                          </v-card-title>

                                          <v-card-text>
                                            <v-container fluid class="no-padding-sides no-margin-sides" style="flex-direction: column">
                                              <v-row class="no-padding-sides no-margin-sides" style="flex-direction: row">
                                                <v-col class="no-padding-sides no-margin-sides">
                                                  <!-- List of Exercise sets -->
                                                  <v-list>
                                                    <draggable :list="block.exercisesSets" @end="endDrag_changeExerciseSetsIndex(block.exercisesSets)">
                                                      <!-- for each exerciseSets -->
                                                      <v-row
                                                        v-for="(exerciseSets, ide) in block.exercisesSets"
                                                        :key="ide"
                                                        style="border: 1px dashed #cecece; background: #fbfbfb; border-width: 1px"
                                                        class="p-2 mb-4 mx-1"
                                                      >
                                                        <v-col>
                                                          <v-row>
                                                            <v-col cols="6" style="display: flex; align-items: center">
                                                              <!-- Move icon -->
                                                              <v-tooltip right>
                                                                <template v-slot:activator="{ on }">
                                                                  <v-icon v-on="on">mdi-arrow-all</v-icon>
                                                                </template>
                                                                <span>Déplacer</span>
                                                              </v-tooltip>

                                                              <!-- Exercise Title -->
                                                              <span v-if="exerciseSets.ex" style="padding-left: 5px; font-size: 19px">
                                                                {{ exerciseSets.ex.title || exerciseSets.ex.name }}
                                                              </span>
                                                            </v-col>
                                                            <!-- Type of Exercise label (ENE or PPG) -->
                                                            <v-col cols="3" class="no-padding-sides">
                                                              <v-chip class="ma-2" color="#0F1547" dark>
                                                                <span style="color: white"> Exercice {{ exerciseSets.ex.title ? "ENE" : "PPG" }} </span>
                                                              </v-chip>
                                                            </v-col>
                                                            <!-- Replace and Delete exercise Buttons -->
                                                            <v-col cols="3">
                                                              <v-row class="justify-content-end" style="display: flex; align-items: center">
                                                                <v-col cols="2" class="no-padding-sides">
                                                                  <!-- Replace Exercise Drop Down List Button-->
                                                                  <v-menu
                                                                    offset-y                                                                    
                                                                    attach
                                                                    v-model="
                                                                      isReplaceMenuOpened[editedItem.index.toString() + '-' + idx.toString() + '-' + ide.toString()]
                                                                    "
                                                                  >
                                                                    <template v-slot:activator="{ on: onMenu, attrs }">
                                                                      <v-tooltip top>
                                                                        <template v-slot:activator="{ on: onTooltip }">
                                                                          <v-btn
                                                                            small
                                                                            v-on="{ ...onMenu, ...onTooltip }"
                                                                            v-bind="attrs"
                                                                            class="md-just-icon md-simple md-primary"
                                                                          >
                                                                            <md-icon>find_replace</md-icon>
                                                                            <md-tooltip md-direction="top"> Remplacer </md-tooltip>
                                                                          </v-btn>
                                                                        </template>
                                                                        <span>Remplacer l'exercice du set</span>
                                                                      </v-tooltip>
                                                                    </template>
                                                                    <v-list>
                                                                      <!-- Replace Exercise ENE -->
                                                                      <v-list-item>
                                                                        <v-dialog
                                                                          persistent
                                                                          no-click-animation
                                                                          :retain-focus="false"
                                                                          v-model="
                                                                            dialogExEneReplace[editedItem.index.toString() + '-' + idx.toString() + '-' + ide.toString()]
                                                                          "
                                                                          transition="dialog-bottom-transition"
                                                                        >
                                                                          <template v-slot:activator="{ on: onReplaceExerciseEne }">
                                                                            <v-btn
                                                                              @click="
                                                                                setBlockExercise(ide);
                                                                                setBlockId(idx);
                                                                              "
                                                                              v-on="onReplaceExerciseEne"
                                                                              style="color: white"
                                                                              color="#0F1547"
                                                                              class="mx-2"
                                                                            >
                                                                              Exercice ENE
                                                                            </v-btn>
                                                                          </template>

                                                                          <v-card class="flex flex-column d-flex" style="height: 90vh">
                                                                            <exercises-list-v2
                                                                              v-show="
                                                                                dialogExEneReplace[
                                                                                  editedItem.index.toString() + '-' + idx.toString() + '-' + ide.toString()
                                                                                ]
                                                                              "
                                                                              :close="closeExEneReplaceDialog"
                                                                              @close-menu="
                                                                                isReplaceMenuOpened[
                                                                                  editedItem.index.toString() + '-' + idx.toString() + '-' + ide.toString()
                                                                                ] = false
                                                                              "
                                                                            />
                                                                          </v-card>
                                                                        </v-dialog>
                                                                      </v-list-item>
                                                                      <!-- Replace Exercise PPG -->
                                                                      <v-list-item>
                                                                        <v-dialog
                                                                          persistent
                                                                          no-click-animation
                                                                          :retain-focus="false"
                                                                          v-model="
                                                                            dialogExPpgReplace[editedItem.index.toString() + '-' + idx.toString() + '-' + ide.toString()]
                                                                          "
                                                                          transition="dialog-bottom-transition"
                                                                        >
                                                                          <template v-slot:activator="{ on: onReplaceExercisePpg }">
                                                                            <v-btn
                                                                              @click="
                                                                                setBlockExercise(ide);
                                                                                setBlockId(idx);
                                                                              "
                                                                              v-on="onReplaceExercisePpg"
                                                                              style="color: white"
                                                                              color="#0F1547"
                                                                              class="mx-2"
                                                                            >
                                                                              Exercice PPG
                                                                            </v-btn>
                                                                          </template>

                                                                          <v-card class="flex flex-column d-flex" style="height: 90vh">
                                                                            <ppg-list-v2
                                                                              v-show="
                                                                                dialogExPpgReplace[
                                                                                  editedItem.index.toString() + '-' + idx.toString() + '-' + ide.toString()
                                                                                ]
                                                                              "
                                                                              :close="closeExPpgReplaceDialog"
                                                                              @close-menu="
                                                                                isReplaceMenuOpened[
                                                                                  editedItem.index.toString() + '-' + idx.toString() + '-' + ide.toString()
                                                                                ] = false
                                                                              "
                                                                            />
                                                                          </v-card>
                                                                        </v-dialog>
                                                                      </v-list-item>
                                                                    </v-list>
                                                                  </v-menu>
                                                                </v-col>

                                                                <v-col cols="2" class="no-padding-sides">
                                                                  <!-- Delete Exercise Button -->
                                                                  <v-tooltip top>
                                                                    <template v-slot:activator="{ on: onTooltip }">
                                                                      <v-btn
                                                                        @click="
                                                                          block.exercisesSets.splice(ide, 1);
                                                                          updater++;
                                                                        "
                                                                        class="md-just-icon md-simple md-primary"
                                                                        v-on="onTooltip"
                                                                        small
                                                                      >
                                                                        <md-icon>delete</md-icon>
                                                                        <md-tooltip md-direction="top">Supprimer</md-tooltip>
                                                                      </v-btn>
                                                                    </template>
                                                                    <span>Supprimer l'exercice du set</span>
                                                                  </v-tooltip>
                                                                </v-col>
                                                              </v-row>
                                                            </v-col>
                                                          </v-row>
                                                          <v-row>
                                                            <v-col :key="updater" cols="3">
                                                              <v-row>
                                                                <!-- Echauffement Button -->
                                                                <v-col cols="12">
                                                                  <v-switch dense label="Échauffement" v-model="exerciseSets.echauffement" />
                                                                </v-col>
                                                                <!-- Sets Button -->
                                                                <v-col cols="12" class="no-padding-sides">
                                                                  <sets-modal :block="block" :exerciseSets="exerciseSets" />
                                                                </v-col>
                                                              </v-row>
                                                            </v-col>

                                                            <v-col cols="3">
                                                              <v-label>Intensité</v-label>

                                                              <v-rating
                                                                color="#1B8A62"
                                                                background-color="#1B8A62"
                                                                v-model="exerciseSets.intensité"
                                                                empty-icon="mdi-hexagon-outline"
                                                                full-icon="mdi-hexagon"
                                                              />

                                                              <v-label>Volume</v-label>

                                                              <v-rating
                                                                color="#1B8A62"
                                                                background-color="#1B8A62"
                                                                v-model="exerciseSets.volume"
                                                                empty-icon="mdi-hexagon-outline"
                                                                full-icon="mdi-hexagon"
                                                              />
                                                            </v-col>

                                                            <v-col cols="2">
                                                              <v-select
                                                                :key="compKey"
                                                                label="Observable(s)"
                                                                multiple
                                                                v-model="exerciseSets.exercisesSetObservables"
                                                                :items="itemStep.etapeObservable"
                                                                return-object
                                                                item-value="observableId"
                                                                item-text="name"
                                                                name="obs"
                                                              />
                                                            </v-col>

                                                            <v-col cols="4">
                                                              <wysiwyg v-model="exerciseSets.critéreRéussite" style="cursor: text" label="Informations complémentaires" />
                                                            </v-col>
                                                          </v-row>
                                                        </v-col>
                                                      </v-row>
                                                    </draggable>
                                                  </v-list>
                                                </v-col>
                                              </v-row>
                                              <v-row class="no-padding-sides no-margin-sides">
                                                <v-col class="no-padding-sides no-margin-sides">
                                                  <!-- Add Exercise Drop Down List Button-->
                                                  <v-menu offset-y attach top v-model="isAddMenuOpened[idx]">
                                                    <template v-slot:activator="{ on: onMenu, attrs }">
                                                      <v-tooltip top>
                                                        <template v-slot:activator="{ on: onTooltip }">
                                                          <v-btn v-on="{ ...onMenu, ...onTooltip }" v-bind="attrs" style="color: white" color="#1B8A62" class="mx-2">
                                                            Ajouter un Exercice
                                                          </v-btn>
                                                        </template>
                                                        <span>Définir l'exercice du set</span>
                                                      </v-tooltip>
                                                    </template>
                                                    <v-list>
                                                      <!-- Add Exercise ENE -->
                                                      <v-list-item>
                                                        <v-dialog persistent :retain-focus="false" v-model="dialogExEneAdd" transition="dialog-bottom-transition">
                                                          <template v-slot:activator="{ on: onAddExerciseEne }">
                                                            <v-btn @click="setBlockId(idx)" v-on="onAddExerciseEne" style="color: white" color="#0F1547" class="mx-2">
                                                              Exercice ENE
                                                            </v-btn>
                                                          </template>

                                                          <v-card class="flex flex-column d-flex" style="height: 90vh">
                                                            <exercises-list-v2
                                                              v-show="dialogExEneAdd"
                                                              :close="closeExEneAddDialog"
                                                              :authorizedDestinationTypes="getCurrentlyAuthorizedDestinationTypes()"
                                                              :isShowed="dialogExEneAdd"
                                                              :gce="gce"
                                                              @close-menu="isAddMenuOpened[idx] = false"
                                                            />
                                                          </v-card>
                                                        </v-dialog>
                                                      </v-list-item>
                                                      <!-- Add Exercise PPG -->
                                                      <v-list-item>
                                                        <v-dialog :retain-focus="false" v-model="dialogExPpgAdd" transition="dialog-bottom-transition">
                                                          <template v-slot:activator="{ on: onAddExercisePpg }">
                                                            <v-btn @click="setBlockId(idx)" v-on="onAddExercisePpg" style="color: white" color="#0F1547" class="mx-2">
                                                              Exercice PPG
                                                            </v-btn>
                                                          </template>

                                                          <v-card class="flex flex-column d-flex" style="height: 90vh">
                                                            <ppg-list-v2
                                                              v-show="dialogExPpgAdd"
                                                              :close="closeExPpgAddDialog"
                                                              @close-menu="isAddMenuOpened[idx] = false"
                                                            />
                                                          </v-card>
                                                        </v-dialog>
                                                      </v-list-item>
                                                    </v-list>
                                                  </v-menu>
                                                </v-col>
                                              </v-row>
                                            </v-container>
                                          </v-card-text>
                                        </v-card>
                                      </v-card-text>

                                      <v-card-actions>
                                        <v-btn
                                          color="blue darken-1"
                                          text
                                          @click="
                                            editedItem.block.push({
                                              name: '',
                                              exercisesSets: [],
                                            })
                                          "
                                          >Ajouter un block</v-btn
                                        >
                                        <v-spacer />

                                        <v-btn color="blue darken-1" text @click="saveSession(editedItem, true)">OK</v-btn>
                                      </v-card-actions>
                                    </v-card>
                                  </v-dialog>

                                  <v-dialog :retain-focus="false" transition="dialog-bottom-transition" v-model="dialogImportSession">
                                    <template v-slot:activator="{ on }">
                                      <v-btn @click="newSession(itemStep, false)" class="mb-2 ml-2" v-on="on"> Importer une session </v-btn>
                                    </template>

                                    <import-sessions-modal :close="closeDialogImportSessions" :cycleId="id" :onSave="saveSession" />
                                  </v-dialog>
                                </v-toolbar>
                              </template>

                              <template v-slot:body="props">
                                <draggable :list="props.items" tag="tbody" @end="endDrag_changeSessionIndex(props.items)">
                                  <tr v-for="(item, index) in props.items" :key="index">
                                    <td>
                                      <v-tooltip left>
                                        <template v-slot:activator="{ on }">
                                          <v-icon v-on="on" small class="page__grab-icon">mdi-arrow-all</v-icon>
                                        </template>
                                        <span>Déplacer</span>
                                      </v-tooltip>
                                    </td>
                                    <td>{{ item.name }}</td>
                                    <td>{{ item.duration }}</td>
                                    <td>{{ item.echauffement }}</td>
                                    <td>{{ item.intensity }}</td>
                                    <td>{{ item.volume }}</td>
                                    <td>{{ item.nbBlocs }}</td>
                                    <td>{{ item.circuits }}</td>
                                    <td>{{ item.nbExercise }}</td>
                                    <td>
                                      <v-icon small class="mr-2" @click="editSession(itemStep, item)">edit</v-icon>
                                      <v-icon small @click="deleteSession(itemStep, item)">delete</v-icon>
                                    </td>
                                  </tr>
                                </draggable>
                              </template>
                            </v-data-table>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-form>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </form>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
import AuthService from "@/services/AuthService";
import { AddOrUpdateCycleAsync, getCycleAsync } from "@/api/cycleApi";
import { getExerciseByIdAsync } from "@/api/exerciseApi";
import { getAllCurrentUserCoachesAsync } from "@/api/teamApi";
import { getAllCurrentUserFederationsAsync } from "@/api/federationsApi";
import { getDisciplineAsync, getAllCurrentUserDisciplinesAsync } from "@/api/disciplinesApi";
import VueTimepicker from "vue2-timepicker";
import { stringToTime, timeToString } from "@/helpers/utils";
import { bus } from "@/main";
import Exercise from "@/containers/Exercise";
import ExercisesList from "@/containers/SelectReference/ExercisesList";
import SetsModal from "./SetsModal";
import ImportSessionsModal from "./ImportSessionsModal";
import { getAgeGroupForDisciplineAsync } from "@/api/ageGroupApi";
import { getPracticeTypeForDisciplineAsync } from "@/api/practiceTypeApi";
import store from "@/store";
import { DestinationType, ExerciseType } from "@/models/enums";
import PermissionsService from "@/services/PermissionsService";
import Draggable from "vuedraggable";
import ExercisesListV2 from "../SelectReference/ExercisesListV2";
import PpgListV2 from "../SelectReference/PpgListV2";

export default {
  name: "exercise-form",

  components: {
    Exercise,
    ExercisesList,
    SetsModal,
    VueTimepicker,
    ImportSessionsModal,
    Draggable,
    ExercisesListV2,
    PpgListV2,
  },

  props: {
    id: {
      type: String | Number,
      default: "0",
    },
    isPrinting: {
      default: true,
      type: Boolean,
    },
  },

  data() {
    return {
      authService: AuthService,
      headers: [
        { value: "grabIcon", sortable: false },
        { text: "Nom", value: "name", sortable: false },
        { text: "Durée totale", value: "duration", sortable: false },
        {
          text: "Echauffement",
          value: "echauffement",
          sortable: false,
        },
        {
          text: "Intensité moyenne",
          value: "intensity",
          sortable: false,
        },
        { text: "Volume moyen", value: "volume", sortable: false },
        { text: "Nombre de blocs", value: "nbBlocs", sortable: false },
        { text: "Dont circuits", value: "circuits", sortable: false },
        {
          text: "Nombre d'exercices",
          value: "nbExercise",
          sortable: false,
        },
        { text: "Actions", value: "action", sortable: false },
      ],
      gce: {
        observable: [],
        etape: [],
      },
      // Validation rules on cycle name (title)
      rules: {
        required: (value) => !!value || "Requis.",
        counter: (value) => (value ? value.length <= 60 : "Max 60 caractères"),
        firstStepValidated: () => this.isFirstStepValid(),
        secondStepValidated: () => this.isSecondStepValid(),
        thirdStepValidated: () => this.isThirdStepValid(),
      },
      currentStep: null,
      compKey: 0,
      etapKey: 0,
      currentStepNumber: 1,
      editedItem: {},
      dialogRef: false,
      dialog: false,
      dialogExEneReplace: {},
      dialogExEneAdd: false,
      dialogExPpgReplace: {},
      dialogExPpgAdd: false,
      dialogEx2: false,
      dialogSessions: false,
      dialogSets: false,
      dialogImportSession: false,
      disciplines: [],
      federations: [],
      coaches: [],
      isReal: false,
      isPrerequis: false,
      refresher: 0,
      blockRefresher: 0,
      setRefresher: 0,
      blockId: null,
      blockExercise: null,
      saving: false,
      updater: 0,
      disciplineAgeGroups: [],
      ageGroupCustomTitle: "",
      selectedAgeGroupIds: [],
      disciplinePracticeTypes: [],
      practiceTypeCustomTitle: "",
      selectedPracticeTypeIds: [],
      DestinationTypes: DestinationType,
      canGoToSecondStep: false,
      canGoToThirdStep: false,
      selectedDestinationType: 1,
      destinationTypeItems: [
        { text: "Transversal", value: DestinationType.PUBLIC },
        { text: "Spécifique", value: DestinationType.DISCIPLINE },
        { text: "Fédéral", value: DestinationType.FEDERAL },
        { text: "Entraîneur", value: DestinationType.COACH },
      ],
      exerciseTypeItems: [
        { text: "Exercice", value: ExerciseType.EXERCISE },
        { text: "Test (évaluation)", value: ExerciseType.EVALUATION },
        {
          text: "Situation de référence",
          value: ExerciseType.REFERENCE,
        },
      ],
      isReplaceMenuOpened: {},
      isAddMenuOpened: [],
    };
  },

  watch: {
    // Add a watcher on the all form in order to trigger form validation when editing the form data
    gce: {
      handler: function (v) {
        this.checkIfStepsAreValid();
      },
      deep: true,
    },
    // Watch the add ENE Exercise dialog v-model in order to emit close to the menu
    dialogExEneAdd(val) {
      if (!val) {
        this.$emit("close-menu");
      }
    },
    // Watch the add PPG Exercise dialog v-model in order to emit close to the menu
    dialogExPpgAdd(val) {
      if (!val) {
        this.$emit("close-menu");
      }
    },
  },

  computed: {
    canManageCurrentCycle() {
      // Can manage own Cycles
      let canManageOwnCycles = PermissionsService.CyclesPermissionsService.canManageOwnCycles && this.gce && this.gce.isAllowedToManageCycle;
      // Can manage all Cycles
      let canManageAllCycles = PermissionsService.CyclesPermissionsService.canManageAllCycles;
      return canManageOwnCycles || canManageAllCycles;
    },

    // Needed to allow federation managers to select federation destination
    canChooseFederationDestinationType() {
      return PermissionsService.FederationsPermissionsService.canManageOwnFederation;
    },
    // Needed to allow discipline managers to select discipline destination
    canChooseDisciplineDestinationType() {
      return PermissionsService.DisciplinesPermissionsService.canManageOwnDiscipline || this.canChooseFederationDestinationType;
    },
    // Needed to allow coaches to select coach destination
    canChooseCoachDestinationType() {
      return PermissionsService.TeamsPermissionsService.canManageOwnTeam || this.canChooseDisciplineDestinationType;
    },
  },

  async mounted() {
    // Init can manage flag with true, will be overriden by fetchCycle if not new Cycle
    this.gce.isAllowedToManageCycle = true;

    // List of federations if admin or super, only one federation if federation manager, discipline manager or coach
    this.federations = await getAllCurrentUserFederationsAsync();
    // List of disciplines if admin, super or federation manager, only one if discipline manager or coach
    this.disciplines = await getAllCurrentUserDisciplinesAsync();
    // List of coaches if admin, super, federation manager or discipline manager, only one if coach
    this.coaches = await getAllCurrentUserCoachesAsync();

    // if we are editing an existing cycle
    if (this.id && this.id !== "0") {
      this.gce.id = this.id;
      this.gce = await getCycleAsync(this.id);

      this.selectedDestinationType = this.gce.destinationType;

      this.gce.etape.forEach((el) => {
        el.etapeObservable.forEach((c) => (c.name = c.observable.name));
        el.session.forEach((session, sessionIndex) => {
          this.addSessionInformations(session);
          session.block.forEach((b, blockIndex) => {
            b.exercisesSets.forEach((e, exIndex) => {
              e.ex = e.exercise || e.ppgExercise;
              // Empty the skills HierarchyId in order for the controller to parse the data
              if (e.ex.exerciseSkills && e.ex.exerciseSkills.length > 0) {
                e.ex.exerciseSkills.forEach((es) => {
                  if (es.skill) {
                    es.skill.hierarchyId = null;
                  }
                });
              }
            });
          });
        });
      });

      if (this.gce.exerciseRéférence) {
        this.gce.exerciseRef = await getExerciseByIdAsync(this.gce.exerciseRéférence);
      }

      // If we are openning in edit mode
      if (this.gce && this.gce.disciplineId) {
        await this.getDisciplineForCustomLabels();
        await this.getAgeGroupsForDiscipline();
        await this.getPracticeTypesForDiscipline();
      }

      // Empty only frontend ageGroups property (used to handle ddl selected values)
      this.selectedAgeGroupIds = [];
      // Get all the many many cycleAgeGroups values and map only the ageGroup id into ageGroups (filling the ddl with values)
      this.gce.cycleAgeGroups.forEach((element) => {
        this.selectedAgeGroupIds.push(element.ageGroupId);
      });

      // Empty only frontend practiceTypes property (used to handle ddl selected values)
      this.selectedPracticeTypeIds = [];
      // Get all the many many cyclePracticeTypes values and map only the practiceType id into practiceTypes (filling the ddl with values)
      this.gce.cyclePracticeTypes.forEach((element) => {
        this.selectedPracticeTypeIds.push(element.practiceTypeId);
      });

      // Check if the steps are valid
      this.checkIfStepsAreValid();
    }
    // else it is a new cycle
    else {
      // Set destinationType radio button default value to Public
      this.selectedDestinationType = DestinationType.PUBLIC;
      this.gce.destinationType = DestinationType.PUBLIC;
    }

    // Check if the user can see this page
    if (!this.canManageCurrentCycle) {
      store.dispatch("setSnackbar", {
        title: `Non Autorisé`,
        text: `Vous n'êtes pas autorisé à consulter cette ressource.`,
        status: "warning",
        timeout: 2000,
      });

      this.$router.replace("/");
    }

    bus.$on("reference", (x, type) => {
      const exerciseTypeId = type === "PPG" ? "ppgExerciseId" : "exerciseId";

      if (this.blockExercise != null) {
        const exerciseSet = this.editedItem.block[this.blockId].exercisesSets[this.blockExercise];

        exerciseSet.exercise = null;
        exerciseSet.exerciseId = null;
        exerciseSet.ppgExercise = null;
        exerciseSet.ppgExerciseId = null;

        Object.assign(exerciseSet, {
          ex: x,
          blockId: this.blockId,
          [exerciseTypeId]: x.id,
        });

        this.blockRefresher++;
      } else if (this.blockId != null) {
        this.editedItem.block[this.blockId].exercisesSets.push({
          ex: x,
          blockId: this.blockId,
          [exerciseTypeId]: x.id,
        });

        this.blockRefresher++;
      } else {
        this.gce.exerciseRef = x;
        this.gce.exerciseRéférence = x.id;
      }

      this.dialog = false;
      this.dialogExEneReplace = {};
      this.dialogExEneAdd = false;
      this.dialogExPpgReplace = {};
      this.dialogExPpgAdd = false;
      this.dialogRef = false;
      this.blockId = null;
      this.blockExercise = null;
    });

    bus.$on("excreated", (ex) => {
      if (this.blockExercise != null) {
        this.editedItem.block[this.blockId].exercisesSets[this.blockExercise] = {
          ex: ex,
          exerciseId: ex.id,
          blockId: this.blockId,
        };
        this.blockRefresher++;
      } else {
        this.gce.exerciseRef = ex;
      }

      this.blockId = null;
      this.blockExercise = null;
      this.dialogExEneReplace = {};
      this.dialogExEneAdd = false;
      this.dialogExPpgReplace = {};
      this.dialogExPpgAdd = false;
      this.dialogEx2 = false;
    });
  },

  methods: {
    closeDialog() {
      this.dialog = false;
    },

    closeDialogImportSessions() {
      this.dialogImportSession = false;
    },

    closeExEneReplaceDialog() {
      this.blockId = null;
      this.blockExercise = null;
      this.dialogExEneReplace = {};
    },

    closeExEneAddDialog() {
      this.blockId = null;
      this.dialogExEneAdd = false;
    },

    closeExPpgReplaceDialog() {
      this.blockId = null;
      this.blockExercise = null;
      this.dialogExPpgReplace = {};
    },

    closeExPpgAddDialog() {
      this.blockId = null;
      this.dialogExPpgAdd = false;
    },

    setBlockId(idx) {
      this.blockId = idx;
    },

    setBlockExercise(idx) {
      this.blockExercise = idx;
    },

    formatEtapeObservables(exerciseSet, observables) {
      const obs = observables.map((observable) => {
        const id = 0;
        const exercisesSetId = exerciseSet.id || 0;

        if (observable.observable) {
          return { ...observable, exercisesSetId, id };
        }

        return { ...observable, exercisesSetId };
      });

      console.log(obs);

      return obs;
    },

    deleteBlock(session, block) {
      if (confirm("Souhaitez-vous supprimer ce block ?")) session.block = session.block.filter((item) => item != block);
    },

    // Asign values to be able to go to next steps
    checkIfStepsAreValid() {
      this.canGoToSecondStep = this.isFirstStepValid();
      this.canGoToThirdStep = this.isSecondStepValid();
    },

    // => Try to validate the first step
    // Return true if validated, false if not
    isFirstStepValid() {
      var result = false;

      if (this.$refs && this.$refs.cycleForm) {
        result = this.$refs.cycleForm.validate();
      } else {
        result = true;
      }

      return result;
    },

    // => Try to validate the first step
    // Validate() the cycle form
    // If OK jump to next step
    //If not OK display the form errors
    onValidateFirstStep() {
      // Check if the step is valid
      var isFirstStepValid = this.isFirstStepValid();

      // If the first step is valid we can go to the next one
      if (isFirstStepValid) {
        this.currentStepNumber = 2;
      }
      // Else we wanna display current errors
      else {
        // Display first step error snackbars
        this.displayFirstStepErrors();
      }
    },

    // Display first step error snackbars
    displayFirstStepErrors() {
      var cycle = this.gce;

      // Handle missing title
      if (!cycle.name) {
        store.dispatch("setSnackbar", {
          title: "Titre requis",
          text: "Veuillez renseigner le titre du cycle.",
          status: "error",
          timeout: 2000,
        });
      }

      // Handle missing destination
      if (!cycle.destinationType) {
        store.dispatch("setSnackbar", {
          title: "Destination requise",
          text: "Veuillez renseigner la destination du cycle.",
          status: "error",
          timeout: 2000,
        });
      }

      // handle destinationType federation but no federation is selected
      if (cycle.destinationType === DestinationType.FEDERAL && !cycle.federationId) {
        store.dispatch("setSnackbar", {
          title: "Fédération requise",
          text: "La destination du cycle est Fédération. Veuillez renseigner la Fédération associée.",
          status: "error",
          timeout: 2000,
        });
      }

      // Handle missing discipline if destination specific selected
      if (cycle.destinationType === DestinationType.DISCIPLINE && !cycle.disciplineId) {
        store.dispatch("setSnackbar", {
          title: "Discipline requise",
          text: "La destination du cycle est Spécifique. Veuillez renseigner la discipline associée.",
          status: "error",
          timeout: 2000,
        });
      }

      // handle destinationType coach but no coach is selected
      if (cycle.destinationType === DestinationType.COACH && !cycle.coachId) {
        store.dispatch("setSnackbar", {
          title: "Entraineur requis",
          text: "La destination du cycle est Entraineur. Veuillez renseigner l'Entraineur associée.",
          status: "error",
          timeout: 2000,
        });
      }
    },

    // Validate the second step
    isSecondStepValid() {
      // there is nothing required in the second step
      return true;
    },

    // There is nothing required here so we can just increase the currentStepNumber
    onValidateSecondStep() {
      this.currentStepNumber = 3;
    },

    // Display second step error snackbars
    displaySecondStepErrors() {
      // var cycle = this.gce;
      // // Handle missing title
      // if (!cycle.name) {
      //   store.dispatch("setSnackbar", {
      //     title: "Titre requis",
      //     text: "Veuillez renseigner le titre du cycle.",
      //     status: "error",
      //     timeout: 2000,
      //   });
      // }
    },

    // Validate the third step
    isThirdStepValid() {
      var result = false;

      // if (this.$refs && this.$refs.etapeForm) {
      //   result = this.$refs.etapeForm.validate();
      // } else {
      result = true;
      // }

      return result;
    },

    // Display thirs step error snackbars
    displayThirdStepErrors(session) {
      // Handle missing session name
      if (!session.name) {
        store.dispatch("setSnackbar", {
          title: "Session : Nom requis",
          text: "Veuillez renseigner le nom de la session.",
          status: "error",
          timeout: 2000,
        });
      }

      // Handle missing block name
      session.block.forEach((bloc, index) => {
        if (!bloc.name) {
          store.dispatch("setSnackbar", {
            title: `Block N° ${index + 1} : Nom requis`,
            text: `Veuillez renseigner le nom du block numéro ${index + 1}.`,
            status: "error",
            timeout: 2000,
          });
        }
      });
    },

    // Submit the all cycle form with all its inner data
    async submitForm() {
      // Check if the step is valid
      var isFirstStepValid = this.isFirstStepValid();
      var isSecondStepValid = this.isSecondStepValid();
      var isThirdStepValid = this.isThirdStepValid();

      // If the form rules are validated
      if (isFirstStepValid && isSecondStepValid && isThirdStepValid) {
        this.saving = true;

        const form = JSON.parse(JSON.stringify(this.gce));
        form.id = this.id;

        form.userId = AuthService.userId;

        form.etape &&
          form.etape.forEach((etape) => {
            if (etape.etapeObservable) {
              const stepObservables = [];

              etape.etapeObservable.forEach((observable) => {
                stepObservables.push({
                  observable: { ...observable },
                });
              });

              etape.etapeObservable = stepObservables;
            }
          });

        // Handle AgeGroup if exists (ddl)
        if (this.selectedAgeGroupIds) {
          // Empty the many many property on Cycle
          form.cycleAgeGroups = [];
          // Add AgeGroup id in a new many many object to be handled by the backend
          this.selectedAgeGroupIds.forEach((exl) => {
            form.cycleAgeGroups.push({ ageGroupId: exl });
          });
        }

        // Handle PracticeType if exists (ddl)
        if (this.selectedPracticeTypeIds) {
          // Empty the many many property on Cycle
          form.cyclePracticeTypes = [];
          // Add PracticeType id in a new many many object to be handled by the backend
          this.selectedPracticeTypeIds.forEach((exl) => {
            form.cyclePracticeTypes.push({ practiceTypeId: exl });
          });
        }

        const result = await AddOrUpdateCycleAsync(form);

        // If we have an id > 0 in the result, the save succeeded
        if (result && result > 0) {
          var createdOrUpdatedMessage = form.id === "0" ? "créé" : "mis à jour";

          store.dispatch("setSnackbar", {
            title: `Cycle ${createdOrUpdatedMessage}`,
            text: `Le cycle a bien été ${createdOrUpdatedMessage}.`,
            status: "success",
            timeout: 2000,
          });
        }

        if (!form.id || form.id === "0") {
          this.gce.id = result;
          this.$router.push(`/cycle/${this.gce.id}`);
        }

        this.saving = false;
      }
      // Else display errors
      else {
        this.displayFirstStepErrors();
        this.displaySecondStepErrors();

        this.gce.etape.forEach((etape) => {
          etape.session.forEach((session) => {
            this.displayThirdStepErrors(session);
          });
        });
      }
    },

    addObservable() {
      this.compKey++;
      this.gce.observable.push({ observableId: this.compKey });
    },

    deleteObservable(item) {
      this.gce.observable = this.gce.observable.filter((row) => row != item);

      if (this.gce.etape) {
        this.gce.etape.forEach((etape) => {
          etape.etapeObservable =
            etape.etapeObservable &&
            etape.etapeObservable.filter((observable) => {
              if (item.observableId) {
                return item.observableId !== observable.observableId;
              } else if (item.id) {
                return item.id !== observable.observableId;
              }
            });
        });
      }
    },

    deleteStep(item) {
      if (confirm("Souhaitez-vous supprimer cette étape ?")) this.gce.etape = this.gce.etape.filter((step) => step !== item);
    },

    newSession(step, openDialog = true) {
      this.currentStep = step;
      this.editedItem = { block: [], index: 1 };
      this.dialogSessions = openDialog;
    },

    // => Join a session to the current cycle
    // ==> Can come from a new session form OR from the import session feature
    // If we come from the session form, we try to validate the etape form which is made from session form and from block forms
    // Display the errors if any
    saveSession(item, isComingFromForm = false) {
      // Validate the etape form if we are not coming from the import session feature
      var result = isComingFromForm ? this.$refs.etapeForm.validate() : true;

      // if the etapeForm is valid
      if (result) {
        this.addSessionInformations(item);

        if (!this.currentStep.session) this.currentStep.session = [];

        const editIdx = this.currentStep.session.findIndex((o) => o.name == item.name);

        if (editIdx == -1) {
          item.block.forEach((b) =>
            b.exercisesSets.forEach((e) => {
              // e.ex is already filled with the data, why affecting e.exercise OR e.ppgExercise ????
              // Because it is javascript and I can't check all possible cases, I added OR e.ex ...
              e.ex = e.exercise || e.ppgExercise || e.ex;
            })
          );

          this.currentStep.session.push(item);
        } else {
          console.log("debug");
          Object.assign(this.currentStep.session[editIdx], item);
        }

        this.refresher++;
        this.dialogSessions = false;

        // Update the position indexes
        this.updateAllSessionsAndExerciseSetsIndexes();
      }
      // Else display the errors
      else {
        // Display thirs step error snackbars
        this.displayThirdStepErrors(item);
      }
    },

    addSessionInformations(session) {
      let totalExercises = 0;
      const volumes = [];
      const intensity = [];

      let totalWarmup = 0;
      let totalDuration = 0;

      session.nbBlocs = session.block.length;
      session.circuits = session.block.filter((block) => block.isCircuit).length;

      session.block.forEach((bloc) => {
        const reps = bloc.nbRep || 1;

        if (bloc.isCircuit && bloc.tpsRecup) {
          if (typeof bloc.tpsRecup == "object") {
            bloc.tpsRecup = `${bloc.tpsRecup.HH}:${bloc.tpsRecup.mm}:${bloc.tpsRecup.ss}`;
          }
          const rest = stringToTime(bloc.tpsRecup);
          totalDuration += rest * reps;
        }

        bloc.exercisesSets.forEach((exerciseSets) => {
          if (exerciseSets.volume) volumes.push(exerciseSets.volume);
          if (exerciseSets.intensité) intensity.push(exerciseSets.intensité);

          exerciseSets.set &&
            exerciseSets.set.forEach((set) => {
              const restDuration = stringToTime(set.tpsDeRécup || "00:00:00");
              const workoutDuration = stringToTime(set.tpsDeTravail || "00:00:00");
              const total = (workoutDuration + restDuration) * reps;

              if (exerciseSets.echauffement) {
                totalWarmup += total;
              }

              totalDuration += total;
            });
        });

        totalExercises += bloc.exercisesSets.length;
      });

      session.nbExercise = totalExercises;
      session.duration = timeToString(totalDuration);
      session.echauffement = timeToString(totalWarmup);

      if (volumes.length) session.volume = Math.round(volumes.reduce((a, b) => a + b) / volumes.length);

      if (intensity.length) session.intensity = Math.round(intensity.reduce((a, b) => a + b) / intensity.length);
    },

    editSession(step, item) {
      this.currentStep = step;
      this.editedItem = item;
      this.dialogSessions = true;
    },

    deleteSession(step, item) {
      if (confirm("Souhaitez-vous supprimer cette session ?")) {
        step.session = step.session.filter((session) => session !== item);

        // Update the position indexes
        this.updateAllSessionsAndExerciseSetsIndexes();
      }

      this.refresher++;
    },

    // Update the position index of the sessions after one being dragged and dropped
    endDrag_changeSessionIndex(sessions) {
      this.updatePositionIndexBasedOnOrder(sessions);
    },

    // Update the position index of the exerciseSets after one beinf dragged and dropped
    endDrag_changeExerciseSetsIndex(exercisesSets) {
      this.updatePositionIndexBasedOnOrder(exercisesSets);
    },

    // Update the position index of items based on the order in the list
    updatePositionIndexBasedOnOrder(items) {
      items.forEach(function (session, index) {
        session.index = index + 1;
      });
    },

    // Update all sessions and all exerciseSets position indexes
    updateAllSessionsAndExerciseSetsIndexes() {
      // Here we wanna update the position index of all sessions and of all exercises
      this.gce.etape.forEach((etape) => {
        // Update the session indexes
        this.updatePositionIndexBasedOnOrder(etape.session);

        etape.session.forEach((sess) => {
          sess.block.forEach((blo) => {
            // Update the exerciseSet indexes
            this.updatePositionIndexBasedOnOrder(blo.exercisesSets);
          });
        });
      });
    },

    addEtap() {
      if (!this.gce.etape) {
        this.gce.etape = [];
      }

      this.gce.etape.push({});
      this.etapKey++;
    },

    // verify existing exercice's destinationType before allowing to change destination
    canEnableDestinationTypeBasedOnExercisesDesinationTypes(destinationType) {
      let result = false;
      let exercisesDestinationTypes = [];

      if (this.gce && this.gce.etape) {
        // for each etape
        this.gce.etape.forEach((etapee) => {
          if (etapee.session) {
            // for each session
            etapee.session.forEach((sessionn) => {
              if (sessionn.block) {
                // for each block
                sessionn.block.forEach((blockk) => {
                  if (blockk.exercisesSets) {
                    // for each exercise set
                    blockk.exercisesSets.forEach((exercisesSet) => {
                      // add the current destination type if doesn't already exists
                      if (exercisesSet.ex && !_.includes(exercisesDestinationTypes, exercisesSet.ex.destinationType)) {
                        exercisesDestinationTypes.push(exercisesSet.ex.destinationType);
                      }
                    });
                  }
                });
              }
            });
          }
        });

        // if new destination type is PUBLIC (transversal)
        if (
          destinationType === DestinationType.PUBLIC &&
          !_.includes(exercisesDestinationTypes, DestinationType.FEDERAL) &&
          !_.includes(exercisesDestinationTypes, DestinationType.DISCIPLINE) &&
          !_.includes(exercisesDestinationTypes, DestinationType.COACH)
        ) {
          result = true;
        }
        // else if new destination type is FEDERAL
        else if (
          destinationType === DestinationType.FEDERAL &&
          !_.includes(exercisesDestinationTypes, DestinationType.DISCIPLINE) &&
          !_.includes(exercisesDestinationTypes, DestinationType.COACH)
        ) {
          result = true;
        }
        // else if new destination type is DISCIPLINE
        else if (destinationType === DestinationType.DISCIPLINE && !_.includes(exercisesDestinationTypes, DestinationType.COACH)) {
          result = true;
        }
        // else if new destination type is COACH
        else if (destinationType === DestinationType.COACH) {
          result = true;
        }
      }

      return result;
    },

    async changeDestination(selectedDestinationType) {
      // hack to bypass bug rendering (needed to click somewhere for the model to update)
      this.gce.destinationType = this.selectedDestinationType;

      // If we selected something else than FEDERAL, we wanna empty FEDERATION RELATED DATA
      if (selectedDestinationType !== DestinationType.FEDERAL) {
        this.gce.federationId = null;
      }
      // Else we wanna auto select first FEDERATION id if there is only one
      else {
        // auto select the first federation
        this.gce.federationId = this.federations[0].id;
      }

      // If we selected DISCIPLINE
      if (selectedDestinationType === DestinationType.DISCIPLINE) {
        // auto select the first discipline
        if (this.gce.disciplineId == null) {
          this.gce.disciplineId = this.disciplines[0].id;
        }
      }

      // If we selected something else than COACH, we wanna empty COACH RELATED DATA
      if (selectedDestinationType !== DestinationType.COACH) {
        this.gce.coachId = null;
        this.gce.coach = null;

        // Empty related age groups
        this.disciplineAgeGroups = [];
        this.gce.cycleAgeGroups = [];
        this.selectedAgeGroupIds = [];

        // Empty related practice types
        this.disciplinePracticeTypes = [];
        this.gce.cyclePracticeTypes = [];
        this.selectedPracticeTypeIds = [];
      }
      // Else we wanna auto select first COACH id if there is only one
      else {
        //auto select first coach
        this.gce.coachId = this.coaches[0].id;
        this.gce.coach = this.coaches[0];
        this.gce.disciplineId = this.coaches[0].coachParentDisciplineId;
        await this.changeDiscipline();
      }

      // Unselect discipline and related if not discipline or coach
      if (selectedDestinationType !== DestinationType.DISCIPLINE && selectedDestinationType !== DestinationType.COACH) {
        this.gce.disciplineId = null;

        // Empty related age groups
        this.disciplineAgeGroups = [];
        this.gce.cycleAgeGroups = [];
        this.selectedAgeGroupIds = [];

        // Empty related practice types
        this.disciplinePracticeTypes = [];
        this.gce.cyclePracticeTypes = [];
        this.selectedPracticeTypeIds = [];
      }
    },

    async changeDiscipline(discipline) {
      await this.getDisciplineForCustomLabels();
      await this.getAgeGroupsForDiscipline();
      await this.getPracticeTypesForDiscipline();
    },

    // On change selected coach, store the selected coach
    // Also, we wanna get related discipline info
    async changeCoach(coach) {
      this.gce.coachId = coach.id;
      this.gce.coach = coach;
      // Update the current discipline id based on the newly selected coach's parent discipline
      // Needed to get discipline related info
      this.gce.disciplineId = coach.coachParentDisciplineId;

      await this.changeDiscipline();
    },

    //Get the list of AgeGroups
    async getAgeGroupsForDiscipline() {
      this.disciplineAgeGroups = await getAgeGroupForDisciplineAsync(this.gce.disciplineId);
      if (!this.disciplineAgeGroups) {
        // store.dispatch("setSnackbar", {
        //   title: "Erreur",
        //   text: "Impossible de récupérer les catégories d'âges de la discipline auprès du serveur",
        //   status: "error",
        //   timeout: 5000,
        // });
      }
    },

    //Get the list of PracticeTypes
    async getPracticeTypesForDiscipline() {
      this.disciplinePracticeTypes = await getPracticeTypeForDisciplineAsync(this.gce.disciplineId);
      if (!this.disciplinePracticeTypes) {
        // store.dispatch("setSnackbar", {
        //   title: "Erreur",
        //   text: "Impossible de récupérer les types de pratiques de la discipline auprès du serveur",
        //   status: "error",
        //   timeout: 5000,
        // });
      }
    },

    // Get the current discipline to use the custom Experience Level title
    async getDisciplineForCustomLabels() {
      if (this.gce && this.gce.disciplineId) {
        var currentDiscipline = await getDisciplineAsync(this.gce.disciplineId);

        if (!currentDiscipline) {
          // store.dispatch("setSnackbar", {
          //   title: "Erreur",
          //   text: "Impossible de récupérer la discipline auprès du serveur",
          //   status: "error",
          //   timeout: 5000,
          // });
        } else {
          // AgeGroup
          this.ageGroupCustomTitle = currentDiscipline.ageGroupCustomTitle ? currentDiscipline.ageGroupCustomTitle : "Catégories d'âges";
          // PracticeType
          this.practiceTypeCustomTitle = currentDiscipline.practiceTypeCustomTitle ? currentDiscipline.practiceTypeCustomTitle : "Type de pratique";
        }
      }
    },

    // get the currently authorized destination types based on selected exercise's destinationType
    getCurrentlyAuthorizedDestinationTypes() {
      if (!this.gce || this.gce.destinationType == DestinationType.UNDEFINED) {
        return [DestinationType.PUBLIC];
      }

      switch (this.gce.destinationType) {
        case DestinationType.PUBLIC:
          return [DestinationType.PUBLIC];
        case DestinationType.FEDERAL:
          return [DestinationType.PUBLIC, DestinationType.FEDERAL];
        case DestinationType.DISCIPLINE:
          return [DestinationType.PUBLIC, DestinationType.FEDERAL, DestinationType.DISCIPLINE];
        case DestinationType.COACH:
          return [DestinationType.PUBLIC, DestinationType.FEDERAL, DestinationType.DISCIPLINE, DestinationType.COACH];
        default:
          return [DestinationType.PUBLIC];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
label {
  border: 0px solid !important;
}

::v-deep .ck-editor__editable {
  min-height: 100px !important;
  max-height: 400px !important;
}

::v-deep .v-radio {
  .v-label {
    margin-bottom: 0px !important;
  }
}

::v-deep .v-card__text {
  .v-input--selection-controls {
    margin-top: 0px !important;
    padding-top: 10px !important;
  }
}

::v-deep .v-toolbar__extension {
  .v-label {
    padding-top: 10px;
    border: none !important;
  }
}

.page--table {
  .page {
    &__table {
      margin-top: 20px;
    }
    &__grab-icon {
      cursor: move;
    }
  }
}
</style>
